// extracted by mini-css-extract-plugin
module.exports = {"root":"TheaterSection_root__YTLcB"};